import React, {useCallback, useEffect, useRef, useState} from 'react';
import Text from '../../../../../components/Text/Text';
import {EmployeePrep, InputGetJob, JobPrep} from '../models';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/redux';
import {RootState} from '../../../../../app/store';
import {UserCredential} from '../../../../login/models';
import {useForm} from 'react-hook-form';
import Button from '../../../../../components/Button/Button';
import BasicDatePicker from "../../../../../components/DatePicker/BasicDatePicker";
import {
    getJobPrepSummary,
    getSingleJobPrep,
    jobPrepGetAction,
} from "../processJobPrep.reducer";
import {HttpClientError, RequestStatus} from "../../../../../http-client";
import {customWarnOption, savedStatusOption} from "../../../../../helpers/alertLabel";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {isArrayEmpty, isObjectEmpty} from "../../../../../helpers/checkEmptiness";
import InputCheckbox from "../../../../../components/Checkbox/InputCheckbox";
import {getPoleByJob, removeMultiplePoleAssign, removePoleAssign, reset} from "../../../../basic/pole/pole.reducer";
import {useSelected} from "../../../../../hooks/checkbox/useSelected";
import {useShiftSelected} from "../../../../../hooks/checkbox/useShiftSelected";
import {MdOutlineDeleteForever} from "react-icons/md";
import {Pole, PoleAssignmentTypeEnum, PoleGetByJobColumnSort} from "../../../../basic/pole/models";
import {CSEmployee} from "../../calcSpec/models";
import AgDataGridStatic from "../../../../../components/DataGrid/AgDataGridStatic";
import {rowNumberRenderer} from "../../../../../components/DataGrid/agGridCustomProps";
import moment from "moment/moment";
import FormLoader from "../../../../../components/Loader/FormLoader";
import {Button as FlowbiteButton} from "flowbite-react";
import {SortingEnum} from "../../../../approval/models";
import {dateSetTimeToNow} from "../../../../../helpers/convert";

const GetJobPrep = ({id = undefined, ...props}: GetJobPrepProps) => {
    const dispatch = useAppDispatch();
    const MySwal = withReactContent(Swal);
    const gridRef = useRef<any>(null);

    const {
        control,
        handleSubmit,
        reset: resetForm,
    } = useForm<InputGetJob>({});

    const [userGetPoles, setUserGetPoles] = useState<Array<EmployeePrep>>([]);
    const [selection, setSelection] = useState<Array<string>>([]);
    const [selectedRemove, setSelectedRemove] = useState<Array<string>>([]);
    const [initialPoleIds, setInitialPoleIds] = useState<Array<string>>([]);

    const job = useAppSelector((state: RootState) => state.processJobPrep.singleJobPrep ?? {} as JobPrep);
    const jobPrepLoading = useAppSelector((state: RootState) => state.processJobPrep.isSingleLoading);
    const isGetLoading = useAppSelector((state: RootState) => state.processJobPrep.isGetLoading);
    const jobPrepSummaryList = useAppSelector((state: RootState) => state.processJobPrep.jobPrepSummaryList ?? []);
    const userState = useAppSelector(
        (state: RootState) => state.user.userAuth ?? ({} as UserCredential)
    );
    const statusPole = useAppSelector((state: RootState) => state.pole.status);
    const errorPole = useAppSelector((state: RootState) => state.pole.error ?? ({} as HttpClientError));
    const pole = useAppSelector(
        (state: RootState) => state.pole.poleByJob ?? []
    );
    const isPoleLoading = useAppSelector(
        (state: RootState) => state.pole.isLoading
    );

    const {selected, change} = useSelected([] as Array<string>);
    const onChange = useShiftSelected(initialPoleIds, change);

    useEffect(() => {
        if (id !== undefined) {
            dispatch(getSingleJobPrep({
                id: id,
                skip: 0,
                take: 1
            }));
            dispatch(getJobPrepSummary(id));
        }
    }, [id]);

    useEffect(() => {
        if (!isObjectEmpty(job)) {
            dispatch(getPoleByJob({job_id: job.id as string, skip: 0, take: 1000, column: PoleGetByJobColumnSort.index, sort: SortingEnum.Ascending}));
        }
    }, [job]);

    useEffect(() => {
        if (!isObjectEmpty(job) && !isArrayEmpty(pole)) {
            let employeeList: Array<EmployeePrep> = job.employee_prep_list ?? [];
            let selectedPoleIds: string[] = [];
            employeeList.map((item: CSEmployee) => {
                selectedPoleIds = [...selectedPoleIds, item.pole_ids ?? ""];
            });
            let _employeeList = pole.map((item: Pole) => {
                const singleEmployee = employeeList.find((employee: EmployeePrep) => employee.pole_ids === item.id) ?? {} as EmployeePrep;
                return {
                    employee_id: singleEmployee?.employee_id ?? "-",
                    employee_name: singleEmployee?.employee_name ?? "-",
                    pole_ids: item.id,
                    pole_sequences: singleEmployee?.pole_sequences ?? "-",
                    isStatic: isObjectEmpty(singleEmployee)
                }
            });
            setUserGetPoles(_employeeList);
            setSelection([...selectedPoleIds]);
            resetForm({date_due: job.date_due === "0001-01-01T00:00:00" ? new Date() : new Date(job.date_due)});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [job, pole]);

    useEffect(() => {
        if (!isArrayEmpty(pole)) {
            const initialPoleIds = pole
                .filter(item => !item.employee_prep_id)
                .map(item => item.id);
            setInitialPoleIds(initialPoleIds);
        }
    }, [pole]);

    useEffect(() => {
        if (statusPole !== undefined && statusPole !== RequestStatus.pending) {
            MySwal.fire(savedStatusOption(statusPole === RequestStatus.success, errorPole.data?.message)).then(() => {
                resetForm();
                setSelectedRemove([]);
                dispatch(reset());
                props.onHide();
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusPole, errorPole]);

    const onSubmit = (data: InputGetJob) => {
        dispatch(jobPrepGetAction({
            id: job.id,
            employee_id: userState.user_id,
            pole_id_list: selected,
            date_due: job.date_due === "0001-01-01T00:00:00" ? dateSetTimeToNow(new Date().toISOString()) : dateSetTimeToNow(new Date(data.date_due).toISOString()),
        }));
    };

    const onDelete = (poleId: string) => {
        MySwal.fire(
            customWarnOption(
                'Remove Get',
                'Are you sure you want to remove this GET? You will not be able to recover this later!',
            )
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(removePoleAssign({
                    poleId: poleId,
                    type: PoleAssignmentTypeEnum.prep
                }));
            }
        });
    }

    const ActionCellRender = (props: any) => {

        if (props.data === undefined) {
            return null;
        }

        return (
            <>
                {
                    userState.user_id === props.data?.employee_id &&
                    <div className="flex align-middle h-[100%]">
                        <button type="button" onClick={() => onDelete(props.data?.pole_ids)}>
                            <MdOutlineDeleteForever className="mr-2 text-2xl text-secondary-color"/>
                        </button>
                    </div>
                }
            </>

        )
    }

    const [columnDefs, _setColumnDefs] = useState([
        {
            headerName: '#',
            field: 'rowNumber',
            cellRenderer: rowNumberRenderer, // Use the custom cell renderer
            suppressSizeToFit: true,
            checkboxSelection: (props: any) => userState.user_id === props.data?.employee_id,
            showDisabledCheckboxes: false,
        },
        {field: 'employee_name', headerName: 'Name', filter: 'agTextColumnFilter'},
        {field: 'pole_sequences', headerName: 'Pole Seq', filter: 'agTextColumnFilter'},
        {
            headerName: 'Actions',
            field: 'actions',
            suppressCellFlash: true,
            cellRenderer: ActionCellRender,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
        },
    ]);

    const onSelectionChanged = useCallback(() => {
        let selectedRows = gridRef.current.api.getSelectedNodes();
        let _selectedRows = selectedRows
            .filter((item: any) => item.data.employee_id === userState.user_id)
            .map((item: any) => item.data.pole_ids);
        setSelectedRemove(_selectedRows);
    }, []);

    const onUnassignHandler = () => {
        const _multipleSelection = selectedRemove.map((item) => {
            return {
                poleId: item,
                type: PoleAssignmentTypeEnum.prep
            }
        });
        MySwal.fire(
            customWarnOption(
                'Remove Get',
                'Are you sure you want to remove this GET? You will not be able to recover this later!',
            )
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeMultiplePoleAssign(_multipleSelection));
            }
        });
    }

    return (
        <div className="p-2 md:p-6 pt-2 md:pt-2 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <FormLoader isLoading={jobPrepLoading || isPoleLoading} label="Fetching Data ...">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex">
                        <div className="w-1/2">
                            <Text label="Job Number" value={job.number_job} suppressBorder/>
                            <Text label="District" value={job.district_name} suppressBorder/>
                            <BasicDatePicker
                                label="Due Date"
                                name="date_due"
                                placeholderText="Select Due Date"
                                control={control}
                            />
                        </div>
                        <div className="w-1/2">
                            <Text label="Job Prep" value={userState.name} suppressBorder/>
                            <Text label="Type" value={job.type_name} suppressBorder/>
                        </div>
                    </div>

                    <div className="h-[36vh] my-5 border border-[#dfdfdf] rounded-lg">
                        <div className="h-[40px] bg-[#e7ebe6] rounded-t-lg flex items-center">
                            <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 px-3">
                                Poles
                            </label>
                        </div>
                        <div className="h-[calc(36vh-50px)] overflow-auto">
                            <div className="grid md:grid-cols-4 gap-4 p-3">
                                {
                                    pole.map((item, index) => (
                                        <div className={"flex"}>
                                            <label
                                                className={`mr-2 text-sm font-bold text-gray-900 dark:text-gray-300`}
                                                htmlFor={item.id}
                                            >
                                                {`${index + 1}.`}
                                            </label>
                                            <InputCheckbox
                                                className="my-3"
                                                label={item.seq ?? ""}
                                                id={item.id}
                                                onChange={(event) => onChange(event, item.id)}
                                                checked={selection.includes(item.id) || selected.includes(item.id)}
                                                picked={selection.includes(item.id)}
                                                disabled={selection.includes(item.id)}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>

                    <div className="h-[36vh] my-5 border border-[#dfdfdf] rounded-lg">
                        <div className="h-[40px] bg-[#e7ebe6] rounded-t-lg flex items-center">
                            <label className="block text-sm font-bold text-gray-700 dark:text-gray-300 px-3">
                                Summary
                            </label>
                        </div>
                        <div className="h-[calc(36vh-40px)] overflow-auto">
                            <div className="flex">
                                <div className="w-1/2 overflow-auto h-[calc(36vh-40px)]">
                                    {
                                        jobPrepSummaryList.map((item) => (
                                            <div
                                                className="flex h-[40px] p-4 items-center text-xs border border-[#dfdfdf] hover:bg-[#fcebe0]">
                                                <div className="w-1/3 truncate">
                                                    <b>{item.employee_name}</b>
                                                </div>
                                                <div className="w-1/3">
                                                    <span className="text-[#919191]">Total Poles </span>
                                                    <b>{item.total}</b>
                                                </div>
                                                <div className="w-1/3">
                                                    <span
                                                        className="text-[#919191]">Date </span><b>{moment(item.date_due).format("D MMM YYYY")}</b>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                                <div className="w-1/2 h-[calc(36vh-40px)]">
                                    <AgDataGridStatic ref={gridRef} columnDefs={columnDefs} rowData={userGetPoles}
                                                      tableDimension={{
                                                          width: '100%',
                                                          height: '100%'
                                                      }} containerClass={"h-[calc(36vh-96px)]"} defaultColDef={{
                                        sortable: true,
                                        resizable: true,
                                        flex: 1,
                                        minWidth: 50,
                                        wrapHeaderText: true,
                                        wrapText: true,
                                        autoHeight: true
                                    }} isRowSelectable={() => true} onSelectionChanged={onSelectionChanged}
                                                      isCustomHeader={true}
                                                      customChildHeaderComponent={
                                                          <>
                                                              <FlowbiteButton
                                                                  onClick={onUnassignHandler}
                                                                  size="xs"
                                                                  color="success"
                                                                  disabled={selectedRemove.length === 0}
                                                              >
                                                                  <MdOutlineDeleteForever className="mr-2 h-5 w-5"/>
                                                                  Unassign Selected ({selectedRemove.length})
                                                              </FlowbiteButton>
                                                          </>
                                                      }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <Button color="success" type="submit" title="Submit" isLoading={isGetLoading}/>
                    </div>
                </form>
            </FormLoader>
        </div>
    );
};

export interface GetJobPrepProps {
    // job: JobPrep;
    id?: string;
    onHide: () => void;
}

export default GetJobPrep;
